import { Product } from './product'

export enum JourneyBasePriceChangeEnum {
  INCREASE = 'INCREASE',
  DECREASE = 'DECREASE'
}

export enum JourneyBasePriceTypeEnum {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE'
}

export const journeyBasePriceChangeEnumMapping: Record<JourneyBasePriceChangeEnum, string> = {
  INCREASE: 'Augmenter',
  DECREASE: 'Diminuer'
}

export const journeyBasePriceTypeEnumMapping: Record<JourneyBasePriceTypeEnum, string> = {
  AMOUNT: 'Euro',
  PERCENTAGE: 'Pourcentage'
}

export interface ProductInput extends Pick<
  Product,
  | 'type'
  | 'name'
  | 'accomodationCategory'
  | 'countryId'
  | 'formulaId'
  | 'minAge'
  | 'maxAge'
  | 'splitAge'
  | 'minSchoolLevel'
  | 'maxSchoolLevel'
  | 'numberOfHoursPerDay'
  | 'numberOfHoursPerWeek'
  | 'minNumberOfStudents'
  | 'maxNumberOfStudents'
  | 'numberOfFullDay'
  | 'numberOfTeachingRoom'
  | 'numberOfTeflPerDay'
  | 'numberOfTeflWithActivityOnly'
  | 'numberOfTeflWithTuitionAndActivity'
  | 'numberOfTeflWithTuitionOnly'
  | 'noTransportGuide'
> {}

export interface JourneyBasePriceInput {
  value: number
  change: JourneyBasePriceChangeEnum
  type: JourneyBasePriceTypeEnum
}
